export enum StatusTransfer {
    Agendada,
    Aprovada,
    Rejeitada,
    Finalizada,
    Integrada,
    CanceladaPeloCliente,
    DevolucaoAprovada,
    DevolucaoConcluida,
    SaqueDevolvido
}